module.exports = __webpack_public_path__ + "assets/ag--initials.10a04c0f.svg";